import utils from 'utils'
import Invoice from '../../fillOpenManage/invoice1/standModel/Invoice'
import ModalPage from '../../fillOpenManage/ovatBill/view/errorModal.html'
import manualContactModal from './view/manualContactModal.html'
import revertDialog from '../../fillOpenManage/invoice1/view/revertDialog.html'
import fullEleInvoiceChooseUkeyModal from '../openedFullEleInvoice/view/openedFullEleInvoiceChooseUkeyModal.html'
import riskWarningModal from './view/riskWarningModal.html'
export default class fullElectricInvoiceListCtrl {
    constructor($scope, $uibModal, logger, httpRequest, $state, getOvatAmtService, sweetalert, invoiceOpenService, initSortService, $timeout, $q, resultTipService, batchHandle, getCodeAndNumber, batchFilterService, operationService, $filter, exportSettingService) {
        function chooseUkey(title, tips) {
            return $uibModal
                .open({
                    template: fullEleInvoiceChooseUkeyModal,
                    controller: 'fullEleInvoiceChooseUkeyModal',
                    backdrop: 'static',
                    openedClass: 'mod-modal mod-modal-lg',
                    resolve: {
                        items1() {
                            return { title, tips }
                        },
                    },
                })
                .result.then(
                    (ukeyId) => {
                        return ukeyId
                    },
                    () => {
                        return ''
                    }
                )
        }
        httpRequest.get_getUserOrgList().then((res) => {
            $scope.orgList = res.data.value
            $scope.selectedOrgs = $scope.orgList.filter((ele) => {
                if (ele.orgId === $scope.userInfo.org.orgId) {
                    ele.checked = true
                }
            })
        })
        $scope.datePickerConfig = {
            autoclose: true, // 当选择一个日期之后是否立即关闭此日期时间选择器。
            minView: 'month', // 日期时间选择器所能够提供的最精确的时间选择视图。 选择日期后，不会再跳转去选择时分秒
            language: 'zh-CN', // 语言
            format: 'yyyy-mm-dd', // 格式
            forceParse: 0, // 是否强制解析输入框中的值
            pickTime: false,
            pickerPosition: 'bottom-right', // 出现的位置 默认值: 'bottom-right' (还支持 : 'bottom-left')
        }
        // const aMonth = utils.genPeriodByMonth()
        const nowDate = new Date()
        let nowYears = nowDate.getFullYear()
        let nowMoths = nowDate.getMonth()
        let _nowDate = new Date(nowYears, nowMoths - 1, nowDate.getDate()) //上个月的今天

        const aMonth = {
            start: $filter('date')(_nowDate, 'yyyy-MM-dd'),
            end: $filter('date')(nowDate, 'yyyy-MM-dd'),
        }

        $scope.param = {
            pageNum: 1,
            pageSize: 10,
            orderMap: {
                applyDate: 'desc',
            },
            param: {},
        }
        $scope.queryParam = {
            pageNum: 1,
            pageSize: 10,
            param: {},
        }
        $scope.reset = function () {
            if ($scope.active == 1) {
                $scope.param.param = {
                    applyDateBegin: aMonth.start,
                    applyDateEnd: aMonth.end,
                    custNameCreditCode: '',
                    custCreditCode: '',
                    custName: '',
                    applicant: '',
                    waitInvoiceStatus: '',
                    invoiceSource: '',
                    busSysId: '',
                    buySysName: '',
                    diskCode: '',
                    diskId: '',
                    ukeyCode: '',
                    ukeyId: '',
                    invType: '61',
                }
            } else if ($scope.active == 2) {
                $scope.param.param = {
                    applyDateBegin: aMonth.start,
                    applyDateEnd: aMonth.end,
                    custNameCreditCode: '',
                    custCreditCode: '',
                    custName: '',
                    applicant: '',
                    waitInvoiceStatus: '',
                    invoiceSource: '',
                    busSysId: '',
                    buySysName: '',
                    diskCode: '',
                    diskId: '',
                    ukeyCode: '',
                    ukeyId: '',
                    invType: '62',
                }
            }
            $scope.param.orgIdList = [$scope.userInfo.org.orgId] // 机构id列表 默认当前机构
            $scope.queryParam.param.selectedOrgs = [$scope.userInfo.org]
        }
        $scope.reset()
        $scope.sysUkeyList = JSON.parse(localStorage.getItem('user_info')).tax4UkeyList
        // 选中的发票
        $scope.selectedInvoices = []
        function initDict() {
            const dict = {
                invType: [
                    {
                        enumCode: '61',
                        enumName: '全电普通发票',
                    },
                    {
                        enumCode: '62',
                        enumName: '全电专用发票',
                    },
                ],
            }
            const dictTypeArr = ['wait_invoice_status', 'is_list', 'invoice_source', 'invoice_status', 'is_pass', 'scan_bill_status', 'ovat_tax_rate', 'ovat_red_reason', 'red_blue_invoice_type', 'open_status', 'yes_no_flag', 'tax4_open_status', 'tax4_difference_tax', 'specific_element']
            httpRequest.get_dictByTypeArr(JSON.stringify(dictTypeArr)).then((res1) => {
                Object.assign(dict, res1.data.value)
            })
            httpRequest.post_outSystemList().then((res) => {
                const list = res.data.value
                const result = [
                    {
                        enumTypeCode: null,
                        enumName: '全部',
                        enumCode: '',
                    },
                ]
                list.forEach((item) => {
                    const tempdata = {
                        enumTypeCode: null,
                        enumName: '',
                        enumCode: '',
                    }
                    tempdata.enumCode = item.busSysId
                    tempdata.enumName = item.busSysName
                    result.push(tempdata)
                })
                dict.out_system = result
            })
            return dict
        }
        $scope.dictionary = initDict()
        httpRequest.get_getSysParam('batch_invoice_permission_conf').then((res) => {
            $scope.invoicPermissions = res.data.value.paramValue == 0 ? false : true
        })

        let stroageStr = 'fullEleInvoice61'
        let paramObj = {}
        function queryList() {
            $scope.param = localStorage[stroageStr] ? JSON.parse(localStorage[stroageStr]) : $scope.param
            $scope.param.param.orgIdList = $scope.queryParam.param.selectedOrgs.map((ele) => {
                return ele.orgId
            })
            let getListApi = 'post_tax4OrdinaryList'
            if ($scope.active === 2) {
                getListApi = 'post_tax4SpecialList'
            }
            httpRequest[getListApi]($scope.param)
                .then((res) => {
                    const result = []
                    res.data.value.list.forEach((invoice) => {
                        result.push(new Invoice(invoice))
                    })
                    $scope.invoiceList = result
                    $scope.totalItems = res.data.value.total
                    $scope.param.pageNum = res.data.value.pageNum
                    $scope.selectedInvoices = []
                })
                .finally(() => {})
            getData()
        }
        $scope.currentOvatAmt = {}
        $scope.$watch('selectedInvoices.length', () => {
            if (!$scope.selectedInvoices.length) {
                $scope.adValoremTotal = $scope.currentOvatAmt.adValoremTotal
                $scope.invoiceNum = $scope.currentOvatAmt.invoiceNum
                $scope.totalAmt = $scope.currentOvatAmt.totalAmt
                $scope.totalTaxamt = $scope.currentOvatAmt.totalTaxamt
                return
            }
            const { adValoremTotal, totalAmt, totalTaxamt } = getOvatAmtService($scope.selectedInvoices)
            $scope.adValoremTotal = adValoremTotal
            $scope.invoiceNum = $scope.selectedInvoices.length
            $scope.totalAmt = totalAmt
            $scope.totalTaxamt = totalTaxamt
        })

        function getData() {
            let getListApi = 'post_tax4OrdinaryWaitStatics'
            if ($scope.active === 2) {
                getListApi = 'post_tax4SpecialWaitStatics'
            }
            httpRequest[getListApi]($scope.param.param).then((res) => {
                $scope.adValoremTotal = res.data.value.adValoremTotal.toFixed(2) || '0.00'
                $scope.invoiceNum = res.data.value.invoiceNum || 0
                $scope.totalAmt = res.data.value.totalAmt.toFixed(2) || '0.00'
                $scope.totalTaxamt = res.data.value.totalTaxamt.toFixed(2) || '0.00'
                $scope.currentOvatAmt = {
                    adValoremTotal: $scope.adValoremTotal,
                    invoiceNum: $scope.invoiceNum,
                    totalAmt: $scope.totalAmt,
                    totalTaxamt: $scope.totalTaxamt,
                }
            })
        }
        // 表头排序
        $scope.orderMap = initSortService(stroageStr)
        $scope.selectedHandle = function () {
            $scope.param.orderMap = {}
            if ($scope.orderMap.sortKey) $scope.param.orderMap[$scope.orderMap.sortKey] = $scope.orderMap.sortVal
            localStorage.setItem(stroageStr, JSON.stringify($scope.param))
            queryList()
        }
        $scope.search = function () {
            localStorage.setItem(stroageStr, JSON.stringify($scope.param))
            queryList()
        }
        // 分页
        $scope.totalItems = 0 // 组件初始化设置总页数
        $scope.currentPage = 1 // 设置显示第一页
        $scope.maxSize = 10 // 每一叶显示记录数
        $scope.pageChanged = function () {
            // 点击页码发起查询
            localStorage.setItem(
                stroageStr,
                JSON.stringify({
                    orderMap: $scope.param.orderMap,
                    pageNum: $scope.param.pageNum,
                    pageSize: $scope.param.pageSize,
                    param: localStorage[stroageStr] ? JSON.parse(localStorage[stroageStr]).param : paramObj,
                })
            )
            queryList()
        }
        $scope.goAddPage = function goAddPage(invType) {
            if ($scope.sysUkeyList && $scope.sysUkeyList.length > 0) {
                $state.go('outputManage.fullElectricInvoice.fullEleInvoice.add', {
                    invType,
                })
            } else {
                logger.logError('您还没有配置金四开票点，不能进行该操作')
            }
        }
        // 电子普票批量操作
        $scope.batchDropdownConfig = {
            btnText: '批量操作',
            options: [
                {
                    text: '批量提交',
                    hasPermit: 'submit_fullEleInvoice',
                    handler() {
                        if ($scope.selectedInvoices.length === 0) {
                            logger.logError('请选择发票')
                            return
                        }
                        batchFilterService
                            .ovatBatchFilter($scope.selectedInvoices, {
                                condition: {
                                    word: 'WAIT_COMMIT',
                                    val: true,
                                },
                                text: '提交',
                            })
                            .then(() => {
                                const invoiceIds = []
                                for (let i = 0; i < $scope.selectedInvoices.length; i++) {
                                    invoiceIds.push($scope.selectedInvoices[i].invoiceId)
                                }
                                utils.loading('系统正在批量处理中，请耐心等待... ')
                                httpRequest.post_tax4OrdinaryBatchSubmit({ invoiceIds: invoiceIds }).then((res) => {
                                    const data = res.data.value
                                    if (res.data.value.error > 0) {
                                        $scope.showOpenErrorModal(data)
                                        return
                                    } else {
                                        logger.logSuccess(`本次共计提交${data.total}条数据，成功${data.success}条，失败${data.error}条。`)
                                    }
                                    $timeout(() => {
                                        queryList()
                                    }, 800)
                                })
                            })
                    },
                },
                {
                    text: '批量开票',
                    hasPermit: 'open_fullEleInvoice',
                    async handler() {
                        if ($scope.selectedInvoices.length === 0) {
                            logger.logError('请选择发票')
                            return
                        }
                        const result = check($scope.selectedInvoices)
                        if (!result) {
                            return
                        }
                        const invoiceIds = $scope.selectedInvoices.map((ele) => {
                            return ele.invoiceId
                        })
                        let blueInvoice = $scope.selectedInvoices.filter((el) => el.isRed == '0')
                        let redInvoice = $scope.selectedInvoices.filter((el) => el.isRed != '0')
                        if (blueInvoice.length > 0 && redInvoice.length > 0) {
                            logger.logError('全电蓝票和全电红票不可同时批量提交，请核对数据，将蓝票和红票分别提交开票。')
                            return
                        }
                        if (blueInvoice.length > 0) {
                            const ukeyId = await chooseUkey('开具全电发票', '您正在进行将全电发票开具的操作，开具成功后，发票会自动流转至已开全电发票')
                            if (ukeyId) {
                                // await httpRequest.post_batchUpdateWaitInvUkeyId({
                                //     invoiceIdList: invoiceIds,
                                //     ukeyId,
                                // })
                                utils.loading('系统正在处理中，请耐心等待... ')
                                httpRequest.post_ordinaryGetMatchInvoice(invoiceIds).then((res) => {
                                    utils.loaded()
                                    if (res.data.value.flag == '1') {
                                        sweetalert.confirm('重复开票风险提示', '批量开票的发票中，存在上一次开票失败的发票，再次开票可能存在重复开票风险，请前往电子税局查看是否已开票。如实际未开票成功，确认后可点击【确定】重新提交开票请求进行开票。确定继续开票？').then(
                                            () => {
                                                batchInvoiceOpen(invoiceIds)
                                            },
                                            () => {
                                                console.log('取消')
                                            }
                                        )
                                    } else {
                                        batchInvoiceOpen(invoiceIds)
                                    }
                                })
                            } else {
                                console.log('取消')
                            }
                        }
                        if (redInvoice.length > 0) {
                            utils.loading('系统正在批量处理中，请耐心等待... ')
                            httpRequest.post_tax4OrdinaryBatchInvoice({ invoiceIds: invoiceIds }).then((res) => {
                                utils.loaded()
                                const data = res.data.value
                                if (res.data.value.error > 0) {
                                    $scope.showOpenErrorModal(data)
                                    return
                                } else {
                                    logger.logSuccess(`本次共计提交${data.total}条数据，成功${data.success}条，失败${data.error}条。`)
                                }
                                queryList()
                            })
                        }
                    },
                },
                {
                    text: '批量删除',
                    hasPermit: 'del_fullEleInvoice',
                    handler() {
                        if ($scope.selectedInvoices.length === 0) {
                            logger.logError('请选择发票')
                            return
                        }
                        batchFilterService
                            .ovatBatchFilter($scope.selectedInvoices, {
                                condition: {
                                    word: 'WAIT_DELETE',
                                    val: true,
                                },
                                text: '删除',
                            })
                            .then((arr) => {
                                const invoiceIds = []
                                for (let i = 0; i < arr.length; i++) {
                                    invoiceIds.push(arr[i].invoiceId)
                                }
                                sweetalert.confirm('操作提醒', '确认删除发票？').then(() => {
                                    httpRequest.post_tax4OrdinaryBatchDelete({ invoiceIds: invoiceIds }).then((res) => {
                                        if (res.data.success) {
                                            logger.logSuccess('删除成功')
                                            $timeout(() => {
                                                queryList()
                                            }, 800)
                                        } else {
                                            logger.logError(res.data.errorMsg)
                                        }
                                    })
                                })
                            })
                    },
                },
                {
                    text: '批量回退',
                    hasPermit: 'reduct_fullEleInvoice',
                    handler() {
                        if ($scope.selectedInvoices.length === 0) {
                            logger.logError('请选择发票')
                            return
                        }
                        for (let i = 0; i < $scope.selectedInvoices.length; i++) {
                            if ($scope.selectedInvoices[i].openStatus == 1) {
                                return logger.logError('您选择数据中存在“开票中”状态的数据，不支持回退，请重新选择！')
                            }
                        }
                        batchFilterService
                            .ovatBatchFilter($scope.selectedInvoices, {
                                condition: {
                                    word: 'WAIT_FALLBACK',
                                    val: true,
                                },
                                text: '回退',
                            })
                            .then((arr) => {
                                const invoiceIds = []
                                for (let i = 0; i < arr.length; i++) {
                                    invoiceIds.push(arr[i].invoiceId)
                                }
                                utils.loading('系统正在处理中，请耐心等待... ')
                                httpRequest.post_ordinaryBatchMatchInvoices(invoiceIds).then((res) => {
                                    utils.loaded()
                                    if (res.data.value.isHasLogin === false) {
                                        sweetalert.confirm('重复开票风险提示', '存在上一次开票失败的发票数据，因开票员未登录无法进行自动匹配，回退发票可能存在重复开票风险，请前往电子税局查看是否已开票。如实际未开票成功，确认后可点击【确定】进行回退。确定继续回退？').then(() => {
                                            batchInvoiceReturn(res.data.value.unMatchIds)
                                        })
                                    } else if (res.data.value.isHasLogin && res.data.value.unMatchIds.length > 0) {
                                        sweetalert.confirm('重复开票风险提示', '批量回退的发票中，存在上一次开票失败的发票，回退发票可能存在重复开票风险，E税云将对这些发票执行自动匹配，若匹配上已开发票，将更新发票数据，不再进行回退。').then(() => {
                                            batchInvoiceReturn(res.data.value.unMatchIds)
                                        })
                                    } else {
                                        logger.logSuccess('批量回退的发票中，存在上一次开票失败的发票，避免重复开票，系统已执行自动匹配，请前往已开具发票列表查看。')
                                        $timeout(() => {
                                            queryList()
                                        }, 800)
                                    }
                                })
                            })
                    },
                },
            ],
        }
        // 电子专票批量操作
        $scope.batchZyDropdownConfig = {
            btnText: '批量操作',
            options: [
                {
                    text: '批量提交',
                    hasPermit: 'submit_fullEleSpeInvoice',
                    handler() {
                        if ($scope.selectedInvoices.length === 0) {
                            logger.logError('请选择发票')
                            return
                        }
                        batchFilterService
                            .ovatBatchFilter($scope.selectedInvoices, {
                                condition: {
                                    word: 'WAIT_COMMIT',
                                    val: true,
                                },
                                text: '提交',
                            })
                            .then(() => {
                                const invoiceIds = []
                                for (let i = 0; i < $scope.selectedInvoices.length; i++) {
                                    invoiceIds.push($scope.selectedInvoices[i].invoiceId)
                                }
                                utils.loading('系统正在批量处理中，请耐心等待... ')
                                httpRequest.post_tax4SpecialBatchSubmit({ invoiceIds: invoiceIds }).then((res) => {
                                    const data = res.data.value
                                    if (res.data.value.error > 0) {
                                        $scope.showOpenErrorModal(data)
                                        return
                                    } else {
                                        logger.logSuccess(`本次共计提交${data.total}条数据，成功${data.success}条，失败${data.error}条。`)
                                    }
                                    queryList()
                                })
                            })
                    },
                },
                {
                    text: '批量开票',
                    hasPermit: 'open_fullEleSpeInvoice',
                    async handler() {
                        if ($scope.selectedInvoices.length === 0) {
                            logger.logError('请选择发票')
                            return
                        }
                        const result = check($scope.selectedInvoices)
                        if (!result) {
                            return
                        }
                        const invoiceIds = $scope.selectedInvoices.map((ele) => {
                            return ele.invoiceId
                        })
                        let blueInvoice = $scope.selectedInvoices.filter((el) => el.isRed == '0')
                        let redInvoice = $scope.selectedInvoices.filter((el) => el.isRed != '0')
                        if (blueInvoice.length > 0 && redInvoice.length > 0) {
                            logger.logError('全电蓝票和全电红票不可同时批量提交，请核对数据，将蓝票和红票分别提交开票。')
                            return
                        }
                        if (blueInvoice.length > 0) {
                            const ukeyId = await chooseUkey('开具全电发票', '您正在进行将全电发票开具的操作，开具成功后，发票会自动流转至已开全电发票')
                            if (ukeyId) {
                                // await httpRequest.post_batchUpdateWaitInvUkeyId({
                                //     invoiceIdList: invoiceIds,
                                //     ukeyId,
                                // })
                                utils.loading('系统正在处理中，请耐心等待... ')
                                httpRequest.post_specialGetMatchInvoice(invoiceIds).then((res) => {
                                    utils.loaded()
                                    if (res.data.value.flag == '1') {
                                        sweetalert.confirm('重复开票风险提示', '批量开票的发票中，存在上一次开票失败的发票，再次开票可能存在重复开票风险，请前往电子税局查看是否已开票。如实际未开票成功，确认后可点击【确定】重新提交开票请求进行开票。确定继续开票？').then(
                                            () => {
                                                batchInvoiceOpen(invoiceIds)
                                            },
                                            () => {
                                                console.log('取消')
                                            }
                                        )
                                    } else {
                                        batchInvoiceOpen(invoiceIds)
                                    }
                                })
                            } else {
                                console.log('取消')
                            }
                        }
                        if (redInvoice.length > 0) {
                            utils.loading('系统正在批量处理中，请耐心等待... ')
                            httpRequest.post_tax4SpecialBatchInvoice({ invoiceIds: invoiceIds }).then((res) => {
                                utils.loaded()
                                const data = res.data.value
                                if (res.data.value.error > 0) {
                                    $scope.showOpenErrorModal(data)
                                    return
                                } else {
                                    logger.logSuccess(`本次共计提交${data.total}条数据，成功${data.success}条，失败${data.error}条。`)
                                }
                                queryList()
                            })
                        }
                    },
                },
                {
                    text: '批量删除',
                    hasPermit: 'del_fullEleSpeInvoice',
                    handler() {
                        if ($scope.selectedInvoices.length === 0) {
                            logger.logError('请选择发票')
                            return
                        }
                        batchFilterService
                            .ovatBatchFilter($scope.selectedInvoices, {
                                condition: {
                                    word: 'WAIT_DELETE',
                                    val: true,
                                },
                                text: '删除',
                            })
                            .then((arr) => {
                                const invoiceIds = []
                                for (let i = 0; i < arr.length; i++) {
                                    invoiceIds.push(arr[i].invoiceId)
                                }
                                sweetalert.confirm('操作提醒', '确认删除发票？').then(() => {
                                    httpRequest.post_tax4SpecialBatchDelete({ invoiceIds: invoiceIds }).then((res) => {
                                        if (res.data.success) {
                                            logger.logSuccess('删除成功')
                                            queryList()
                                        } else {
                                            logger.logError(res.data.errorMsg)
                                        }
                                    })
                                })
                            })
                    },
                },
                {
                    text: '批量回退',
                    hasPermit: 'reduct_fullEleSpeInvoice',
                    handler() {
                        if ($scope.selectedInvoices.length === 0) {
                            logger.logError('请选择发票')
                            return
                        }
                        batchFilterService
                            .ovatBatchFilter($scope.selectedInvoices, {
                                condition: {
                                    word: 'WAIT_FALLBACK',
                                    val: true,
                                },
                                text: '批量回退',
                            })
                            .then((arr) => {
                                const invoiceIds = []
                                for (let i = 0; i < arr.length; i++) {
                                    invoiceIds.push(arr[i].invoiceId)
                                }
                                utils.loading('系统正在处理中，请耐心等待... ')
                                httpRequest.post_specialBatchMatchInvoices(invoiceIds).then((res) => {
                                    utils.loaded()
                                    if (res.data.value.isHasLogin === false) {
                                        sweetalert.confirm('重复开票风险提示', '存在上一次开票失败的发票数据，因开票员未登录无法进行自动匹配，回退发票可能存在重复开票风险，请前往电子税局查看是否已开票。如实际未开票成功，确认后可点击【确定】进行回退。确定继续回退？').then(() => {
                                            batchInvoiceReturn(res.data.value.unMatchIds)
                                        })
                                    } else if (res.data.value.isHasLogin && res.data.value.unMatchIds.length > 0) {
                                        sweetalert.confirm('重复开票风险提示', '批量回退的发票中，存在上一次开票失败的发票，回退发票可能存在重复开票风险，E税云将对这些发票执行自动匹配，若匹配上已开发票，将更新发票数据，不再进行回退。').then(() => {
                                            batchInvoiceReturn(res.data.value.unMatchIds)
                                        })
                                    } else {
                                        logger.logSuccess('批量回退的发票中，存在上一次开票失败的发票，避免重复开票，系统已执行自动匹配，请前往已开具发票列表查看。')
                                        $timeout(() => {
                                            queryList()
                                        }, 800)
                                    }
                                })
                            })
                    },
                },
            ],
        }
        // 开票前置
        function invoiceOpenBefore(item, ukeyId) {
            //  httpRequest.post_batchUpdateWaitInvUkeyId({
            //     invoiceIdList: [item.invoiceId],
            //     ukeyId,
            // })
            utils.loading('系统正在处理中，请耐心等待... ')
            let getListApi = 'post_ordinaryGetMatchInvoice'
            if ($scope.active === 2) {
                getListApi = 'post_specialGetMatchInvoice'
            }
            httpRequest[getListApi]([item.invoiceId]).then((res) => {
                utils.loaded()
                if (res.data.value.invoices.length > 0) {
                    $uibModal
                        .open({
                            template: riskWarningModal,
                            controller: 'riskWarningModalCtrl',
                            backdrop: 'static',
                            openedClass: 'mod-modal mod-modal-too-hg',
                            resolve: {
                                items1() {
                                    return {
                                        value: 1,
                                        invoiceList: res.data.value.invoices,
                                    }
                                },
                            },
                        })
                        .result.then((data) => {
                            if (data === '关联') {
                                queryList()
                            } else if (data) {
                                oneInvoiceOpen(item.invoiceId)
                            }
                        })
                } else if (res.data.value.flag == '1') {
                    sweetalert.confirm('重复开票风险提示', '当前发票数据上一次开票失败，请前往电子税局查看是否已开票成功。如实际已开票成功，请进行手工关联，避免重复开票；如实际未开票成功，确认后可点击【确定】重新提交开票请求进行开票。确定继续开票？').then(
                        () => {
                            oneInvoiceOpen(item.invoiceId)
                        },
                        () => {
                            console.log('取消')
                        }
                    )
                } else {
                    oneInvoiceOpen(item.invoiceId)
                }
            })
        }
        // 批量开票
        function batchInvoiceOpen(invoiceIds, index, successNum, errorNum) {
            let i = index ? index : 0
            let total = invoiceIds.length
            let success = successNum ? successNum : 0
            let error = errorNum ? errorNum : 0
            let getListApi = 'post_tax4OrdinaryBatchInvoice'
            if ($scope.active === 2) {
                getListApi = 'post_tax4SpecialBatchInvoice'
            }
            utils.loading(`当前执行批量开票的发票份数为${total}张，正在开具第 ${i + 1} 张发票`)
            $scope.isCon = false
            httpRequest[getListApi]({ invoiceIds: [invoiceIds[i]] })
                .then((res) => {
                    if (res.data.value.error === 1) error++
                    if (res.data.value.success === 1) success++
                    i++
                    if (i !== total) {
                        batchInvoiceOpen(invoiceIds, i, success, error)
                    } else {
                        utils.loaded()
                        logger.logMsg({
                            title: '操作结果',
                            icon: 1,
                            message: `共计${total}张发票,成功${success}张，失败${error}张！开具成功的发票请到【已开全电票】列表查看`,
                        })
                    }
                    $scope.isCon = true
                })
                .finally(() => {
                    if (!$scope.isCon) {
                        utils.loaded()
                        logger.logMsg({
                            icon: 1,
                            message: `当前执行批量开票的发票份数为${total}张，开票任务因异常原因：系统异常 已中断，已开票 ${success} 张发票。`,
                        })
                    }
                    queryList()
                })
        }
        // 单张开票
        function oneInvoiceOpen(invoiceId) {
            let getListApi = 'post_tax4OrdinaryInvoice'
            if ($scope.active === 2) {
                getListApi = 'post_tax4SpecialInvoice'
            }
            utils.loading('开票中，请耐心等待')
            httpRequest[getListApi](invoiceId).then((res) => {
                logger.logSuccess('请求成功，请稍后查看。')
                queryList()
            })
        }
        // 批量回退
        function batchInvoiceReturn(invoiceIds) {
            let getListApi = 'post_tax4OrdinaryBatchReduction'
            if ($scope.active === 2) {
                getListApi = 'post_tax4SpecialBatchReduction'
            }
            utils.loading('系统正在批量处理中，请耐心等待... ')
            httpRequest[getListApi]({ invoiceIds: invoiceIds }).then((res) => {
                const data = res.data.value
                if (res.data.value.error > 0) {
                    $scope.showOpenErrorModal(data)
                    return
                } else {
                    logger.logSuccess(`本次共计提交${data.total}条数据，成功${data.success}条，失败${data.error}条。`)
                }
                $timeout(() => {
                    queryList()
                }, 800)
            })
        }
        // 单张回退
        function oneInvoiceReturn(item) {
            let getListApi = 'post_tax4OrdinaryBatchReduction'
            if ($scope.active === 2) {
                getListApi = 'post_tax4SpecialBatchReduction'
            }
            sweetalert.confirm('操作提醒', '确认回退本张发票？').then(() => {
                let invoiceIds = []
                invoiceIds.push(item.invoiceId)
                httpRequest.post_tax4InvoiceReductionCheck(invoiceIds).then((res) => {
                    let checkresult = res.data.value
                    if (checkresult[0].waitIds === null || checkresult[0].waitIds.length === 0) {
                        httpRequest[getListApi]({ invoiceIds: invoiceIds }).then((res) => {
                            if (res.data.value.error > 0) {
                                logger.logError(res.data.value.messageList[0].errorMsg)
                            } else if (item.billNum > 0) {
                                logger.logSuccess('回退成功，请回到待处理单据中处理开票。')
                            } else if (item.isRed == '0') {
                                logger.logSuccess('回退成功，可重新编辑、开票或删除。')
                            } else {
                                logger.logSuccess('全电红字发票回退成功，请到红字确认单页面进行后续处理！')
                            }
                            queryList()
                        })
                    } else {
                        // 确认弹窗
                        $uibModal
                            .open({
                                template: revertDialog,
                                controller: [
                                    '$scope',
                                    '$uibModalInstance',
                                    function ctrl(scope, uibModalInstance) {
                                        scope.revertData = checkresult[0]
                                        scope.cancel = function cancel() {
                                            uibModalInstance.dismiss()
                                        }
                                        scope.ok = function ok() {
                                            uibModalInstance.close()
                                        }
                                    },
                                ],
                                backdrop: 'static',
                                openedClass: 'mod-modal mod-modal-md',
                                resolve: {},
                            })
                            .result.then(() => {
                                httpRequest[getListApi]({ invoiceIds: invoiceIds }).then((res) => {
                                    if (res.data.value.error > 0) {
                                        logger.logError(res.data.value.messageList[0].errorMsg)
                                    } else if (item.billNum > 0) {
                                        logger.logSuccess('回退成功，请回到待处理单据中处理开票。')
                                    } else if (item.isRed == '0') {
                                        logger.logSuccess('回退成功，可重新编辑、开票或删除。')
                                    } else {
                                        logger.logSuccess('全电红字发票回退成功，请到红字确认单页面进行后续处理！')
                                    }
                                    queryList()
                                })
                            })
                    }
                })
            })
        }
        function check(invoiceList, isPrint) {
            const userInfo = JSON.parse(localStorage.getItem('user_info'))
            if (userInfo.sale.taxplayerType === '3' || userInfo.sale.taxplayerType === '4' || userInfo.sale.taxplayerType === '9') {
                logger.logError('您所在企业纳税人类型不具备开票资格')
                return false
            }
            const hasErrorList = []
            for (let i = 0; i < invoiceList.length; i++) {
                if (!invoiceList[i].authMap.WAIT_BILLING) {
                    logger.logError('您选择的数据中有非“审批通过”状态的数据或"开具中"的数据，不能开票，请重新选择')
                    return false
                }
                if (invoiceList[i].invoiceResultDesc) {
                    hasErrorList.push({
                        infoId: invoiceList[i].waitId,
                        errorMsg: invoiceList[i].invoiceResultDesc,
                    })
                }
            }
            let invStatus = invoiceList.some((el) => el.invoiceSource == 'interface' && el.openStatus == '2')
            if (!$scope.invoicPermissions && invStatus) {
                logger.logError('数据来源为“接口”且开票状态为“失败”的发票限制手工开具，请业务系统源头发起。')
                return false
            }
            return hasErrorList
        }

        //电子普票列表下拉按钮
        $scope.tableDropdownConfig = [
            {
                label: '详情',
                handler(item) {
                    let url
                    if (item.specificElements == '06') {
                        // 不动产租赁服务
                        url = 'outputManage.fullElectricInvoice.fullEleInvoice.realEstateDetail'
                    } else if (item.specificElements == '03') {
                        // 建筑服务
                        url = 'outputManage.fullElectricInvoice.fullEleInvoice.constructionDetail'
                    } else {
                        url = 'outputManage.fullElectricInvoice.fullEleInvoice.detail'
                    }
                    window.open(
                        $state.href(
                            url,
                            {
                                invoiceId: item.invoiceId,
                                invType: item.invType,
                            },
                            {
                                reload: true,
                            }
                        ),
                        '_blank'
                    )
                },
                showWhile() {
                    return true
                },
            },
            {
                label: '编辑',
                handler(item) {
                    $state.go('outputManage.fullElectricInvoice.fullEleInvoice.edit', {
                        invoiceId: item.invoiceId,
                    })
                },
                showWhile(item, hasPermit) {
                    return item.authMap && item.authMap.WAIT_EDIT && hasPermit('edit_fullEleInvoice') && item.openStatus !== 4 && item.openStatus !== 5
                },
            },
            {
                label: '提交',
                handler(item) {
                    sweetalert.confirm('操作提醒', '确认提交本张发票？').then(() => {
                        let invoiceIds = []
                        invoiceIds.push(item.invoiceId)
                        httpRequest.post_tax4OrdinaryBatchSubmit({ invoiceIds: invoiceIds }).then((res) => {
                            if (res.data.value.error > 0) {
                                logger.logError(res.data.value.messageList[0].errorMsg)
                            } else {
                                logger.logSuccess('提交成功')
                            }
                            queryList()
                        })
                    })
                },
                showWhile(item, hasPermit) {
                    return hasPermit('submit_fullEleInvoice') && item.authMap && item.authMap.WAIT_COMMIT && item.openStatus !== 4 && item.openStatus !== 5
                },
            },
            {
                label: '开票',
                async handler(item) {
                    if (!invStatusCheck([item])) return
                    if (item.isRed == '0') {
                        let ukeyId = ''
                        //发票的开票状态为【开票失败】，点击行按钮【开票】，不再弹出“选择开票点”弹窗，弹出提示弹窗
                        if (item.openStatus == '2') {
                            sweetalert.confirm('提示', '当前发票上一次开票失败，只能按照原开票点' + item.ukeyCode + '提交开票，若要修改开票点，请回退后重新开票，是否确认开票？').then(
                                () => {
                                    invoiceOpenBefore(item, ukeyId)
                                },
                                () => {
                                    console.log('取消')
                                }
                            )
                        } else {
                            ukeyId = await chooseUkey('开具全电发票', '您正在进行将全电发票开具的操作，开具成功后，发票会自动流转至已开全电发票')
                        }
                        if (ukeyId) {
                            await invoiceOpenBefore(item, ukeyId)
                        } else {
                            console.log('取消')
                        }
                    } else {
                        oneInvoiceOpen(item.invoiceId)
                    }
                },
                showWhile(item, hasPermit) {
                    return hasPermit('open_fullEleInvoice') && item.authMap && item.authMap.WAIT_BILLING && item.openStatus !== 0 && item.openStatus !== 4 && item.openStatus !== 5
                },
            },
            {
                label: '回退',
                handler(item, index) {
                    utils.loading('系统正在处理中，请耐心等待... ')
                    httpRequest.post_ordinaryGetMatchInvoice([item.invoiceId]).then((res) => {
                        utils.loaded()
                        if (res.data.value.invoices.length > 0) {
                            $uibModal
                                .open({
                                    template: riskWarningModal,
                                    controller: 'riskWarningModalCtrl',
                                    backdrop: 'static',
                                    openedClass: 'mod-modal mod-modal-too-hg',
                                    resolve: {
                                        items1() {
                                            return {
                                                value: 2,
                                                invoiceList: res.data.value.invoices,
                                            }
                                        },
                                    },
                                })
                                .result.then((data) => {
                                    if (data === '关联') {
                                        queryList()
                                    } else if (data) {
                                        oneInvoiceReturn(item)
                                    }
                                })
                        } else if (res.data.value.flag == '1') {
                            sweetalert.confirm('重复开票风险提示', '当前发票数据上一次开票失败，请前往电子税局查看是否已开票成功。如实际已开票成功，请进行手工关联，避免重复开票；如实际未开票成功，确认后可点击【确定】进行回退。确定继续回退？').then(
                                () => {
                                    oneInvoiceReturn(item)
                                },
                                () => {
                                    console.log('取消')
                                }
                            )
                        } else if (res.data.value.flag == '2') {
                            sweetalert.confirm('重复开票风险提示', '存在上一次开票失败的发票数据，因开票员未登录无法进行自动匹配，回退发票可能存在重复开票风险，请前往电子税局查看是否已开票。如实际未开票成功，确认后可点击【确定】进行回退。确定继续回退？').then(
                                () => {
                                    oneInvoiceReturn(item)
                                },
                                () => {
                                    console.log('取消')
                                }
                            )
                        } else {
                            oneInvoiceReturn(item)
                        }
                    })
                },
                showWhile(item, hasPermit) {
                    return hasPermit('reduct_fullEleInvoice') && item.authMap && item.authMap.WAIT_FALLBACK && item.openStatus !== 0 && item.openStatus !== 4 && item.openStatus !== 5
                },
            },
            {
                label: '删除',
                handler(item) {
                    sweetalert.confirm('删除提醒', '确认删除此发票?').then(() => {
                        let invoiceIds = []
                        invoiceIds.push(item.invoiceId)
                        httpRequest.post_tax4OrdinaryBatchDelete({ invoiceIds: invoiceIds }).then((res) => {
                            if (res.data.value.error > 0) {
                                logger.logError(res.data.value.messageList[0].errorMsg)
                            } else {
                                logger.logSuccess('删除成功')
                            }
                            queryList()
                        })
                    })
                },
                showWhile(item, hasPermit) {
                    return hasPermit('del_fullEleInvoice') && item.authMap && item.authMap.WAIT_DELETE && item.openStatus !== 4 && item.openStatus !== 5
                },
            },
            {
                label: '状态刷新',
                handler(item) {
                    httpRequest.post_tax4OrdinaryRefreshOpenStatus({ invoiceId: item.invoiceId }).then(() => {
                        logger.logSuccess('状态刷新成功')
                        queryList()
                    })
                },
                showWhile(item) {
                    return item.openStatus == 0 || item.openStatus == 5
                },
            },
            {
                label: '获取开票结果',
                handler(item) {
                    httpRequest.post_tax4OrdinaryRefreshOpenStatus({ invoiceId: item.invoiceId }).then(() => {
                        logger.logSuccess('获取开票结果成功')
                        queryList()
                    })
                },
                showWhile(item) {
                    return item.openStatus == 1 && item.isRed == '1'
                },
            },
        ]
        //电子专票列表下拉按钮
        $scope.eleTableDropdownConfig = [
            {
                label: '详情',
                handler(item) {
                    let url
                    if (item.specificElements == '06') {
                        // 不动产租赁服务
                        url = 'outputManage.fullElectricInvoice.fullEleInvoice.realEstateDetail'
                    } else if (item.specificElements == '03') {
                        // 建筑服务
                        url = 'outputManage.fullElectricInvoice.fullEleInvoice.constructionDetail'
                    } else {
                        url = 'outputManage.fullElectricInvoice.fullEleInvoice.detail'
                    }
                    window.open(
                        $state.href(
                            url,
                            {
                                invoiceId: item.invoiceId,
                                invType: item.invType,
                            },
                            {
                                reload: true,
                            }
                        ),
                        '_blank'
                    )
                },
                showWhile() {
                    return true
                },
            },
            {
                label: '编辑',
                handler(item) {
                    $state.go('outputManage.fullElectricInvoice.fullEleInvoice.edit', {
                        invoiceId: item.invoiceId,
                    })
                },
                showWhile(item, hasPermit) {
                    return item.authMap && item.authMap.WAIT_EDIT && hasPermit('edit_fullEleSpeInvoice') && item.openStatus !== 4 && item.openStatus !== 5
                },
            },
            {
                label: '提交',
                handler(item) {
                    sweetalert.confirm('操作提醒', '确认提交本张发票？').then(() => {
                        let invoiceIds = []
                        invoiceIds.push(item.invoiceId)
                        httpRequest.post_tax4SpecialBatchSubmit({ invoiceIds: invoiceIds }).then((res) => {
                            if (res.data.value.error > 0) {
                                logger.logError(res.data.value.messageList[0].errorMsg)
                            } else {
                                logger.logSuccess('提交成功')
                            }
                            queryList()
                        })
                    })
                },
                showWhile(item, hasPermit) {
                    return hasPermit('submit_fullEleSpeInvoice') && item.authMap && item.authMap.WAIT_COMMIT && item.openStatus !== 4 && item.openStatus !== 5
                },
            },
            {
                label: '开票',
                async handler(item) {
                    if (!invStatusCheck([item])) return
                    if (item.isRed == '0') {
                        let ukeyId = ''
                        //发票的开票状态为【开票失败】，点击行按钮【开票】，不再弹出“选择开票点”弹窗，弹出提示弹窗
                        if (item.openStatus == '2') {
                            sweetalert.confirm('提示', '当前发票上一次开票失败，只能按照原开票点' + item.ukeyCode + '提交开票，若要修改开票点，请回退后重新开票，是否确认开票？').then(
                                () => {
                                    invoiceOpenBefore(item, ukeyId)
                                },
                                () => {
                                    console.log('取消')
                                }
                            )
                        } else {
                            ukeyId = await chooseUkey('开具全电发票', '您正在进行将全电发票开具的操作，开具成功后，发票会自动流转至已开全电发票')
                        }
                        if (ukeyId) {
                            await invoiceOpenBefore(item, ukeyId)
                        } else {
                            console.log('取消')
                        }
                    } else {
                        oneInvoiceOpen(item.invoiceId)
                    }
                },
                showWhile(item, hasPermit) {
                    return hasPermit('open_fullEleSpeInvoice') && item.authMap && item.authMap.WAIT_BILLING && item.openStatus !== 0 && item.openStatus !== 4 && item.openStatus !== 5
                },
            },
            {
                label: '回退',
                handler(item, index) {
                    utils.loading('系统正在处理中，请耐心等待... ')
                    httpRequest.post_specialGetMatchInvoice([item.invoiceId]).then((res) => {
                        utils.loaded()
                        if (res.data.value.invoices.length > 0) {
                            $uibModal
                                .open({
                                    template: riskWarningModal,
                                    controller: 'riskWarningModalCtrl',
                                    backdrop: 'static',
                                    openedClass: 'mod-modal mod-modal-too-hg',
                                    resolve: {
                                        items1() {
                                            return {
                                                value: 2,
                                                invoiceList: res.data.value.invoices,
                                            }
                                        },
                                    },
                                })
                                .result.then((data) => {
                                    if (data === '关联') {
                                        queryList()
                                    } else if (data) {
                                        oneInvoiceReturn(item)
                                    }
                                })
                        } else if (res.data.value.flag == '1') {
                            sweetalert.confirm('重复开票风险提示', '当前发票数据上一次开票失败，请前往电子税局查看是否已开票成功。如实际已开票成功，请进行手工关联，避免重复开票；如实际未开票成功，确认后可点击【确定】进行回退。确定继续回退？').then(
                                () => {
                                    oneInvoiceReturn(item)
                                },
                                () => {
                                    console.log('取消')
                                }
                            )
                        } else if (res.data.value.flag == '2') {
                            sweetalert.confirm('重复开票风险提示', '存在上一次开票失败的发票数据，因开票员未登录无法进行自动匹配，回退发票可能存在重复开票风险，请前往电子税局查看是否已开票。如实际未开票成功，确认后可点击【确定】进行回退。确定继续回退？').then(
                                () => {
                                    oneInvoiceReturn(item)
                                },
                                () => {
                                    console.log('取消')
                                }
                            )
                        } else {
                            oneInvoiceReturn(item)
                        }
                    })
                },
                showWhile(item, hasPermit) {
                    return hasPermit('reduct_fullEleSpeInvoice') && item.authMap && item.authMap.WAIT_FALLBACK && item.openStatus !== 0 && item.openStatus !== 4 && item.openStatus !== 5
                },
            },
            {
                label: '删除',
                handler(item) {
                    sweetalert.confirm('删除提醒', '确认删除此发票?').then(() => {
                        let invoiceIds = []
                        invoiceIds.push(item.invoiceId)
                        httpRequest
                            .post_tax4SpecialBatchDelete({
                                invoiceIds: invoiceIds,
                            })
                            .then((res) => {
                                if (res.data.value.error > 0) {
                                    logger.logError(res.data.value.messageList[0].errorMsg)
                                } else {
                                    logger.logSuccess('删除成功')
                                }
                                queryList()
                            })
                    })
                },
                showWhile(item, hasPermit) {
                    return hasPermit('del_fullEleSpeInvoice') && item.authMap && item.authMap.WAIT_DELETE && item.openStatus !== 4 && item.openStatus !== 5
                },
            },
            {
                label: '状态刷新',
                handler(item) {
                    httpRequest.post_tax4SpecialRefreshOpenStatus({ invoiceId: item.invoiceId }).then(() => {
                        logger.logSuccess('状态刷新成功')
                        queryList()
                    })
                },
                showWhile(item) {
                    return item.openStatus == 0 || item.openStatus == 5
                },
            },
            {
                label: '获取开票结果',
                handler(item) {
                    httpRequest.post_tax4OrdinaryRefreshOpenStatus({ invoiceId: item.invoiceId }).then(() => {
                        logger.logSuccess('获取开票结果成功')
                        queryList()
                    })
                },
                showWhile(item) {
                    return item.openStatus == 1 && item.isRed == '1'
                },
            },
        ]
        $scope.filterUkeyName = function filterUkeyName(id) {
            const userInfo = JSON.parse(localStorage.getItem('user_info'))
            if (id === null) {
                return id
            }
            if (userInfo.sysUkeyList === null) {
                return id
            }
            const fliterUkeyNameArr = userInfo.sysUkeyList.filter((item) => item.ukeyId === id)
            if (fliterUkeyNameArr.length > 0) {
                return fliterUkeyNameArr[0].ukeyName
            }
            return id
        }
        // 查看关联销售单
        $scope.relatedBill = function relatedBill(item) {
            if (item.billNum === 0) {
                return
            }
            if (item.invoiceId === undefined) {
                return
            }
            $state.go('outputManage.fullElectricInvoice.fullEleInvoice.relatedBill', {
                waitId: item.invoiceId,
            })
        }
        $scope.tabChange = function tabChange(v) {
            $scope.invoiceList = []
            $scope.param.pageNum = 1
            $scope.param.orderMap = {
                applyDate: 'desc',
            }
            $scope.orderMap = {
                applyDate: 'desc',
            }
            $scope.active = v
            $scope.reset()
            if (v == 1) {
                //全电普票
                stroageStr = 'fullEleInvoice61'
                paramObj = {
                    applyDateBegin: aMonth.start,
                    applyDateEnd: aMonth.end,
                    custNameCreditCode: '',
                    custCreditCode: '',
                    custName: '',
                    applicant: '',
                    waitInvoiceStatus: '',
                    invoiceSource: '',
                    busSysId: '',
                    buySysName: '',
                    diskCode: '',
                    diskId: '',
                    ukeyCode: '',
                    ukeyId: '',
                    invType: '61',
                }
                $scope.profileType = '200'
            } else if (v == 2) {
                //全电专票
                stroageStr = 'fullEleInvoice62'
                paramObj = {
                    applyDateBegin: aMonth.start,
                    applyDateEnd: aMonth.end,
                    custNameCreditCode: '',
                    custCreditCode: '',
                    custName: '',
                    applicant: '',
                    waitInvoiceStatus: '',
                    invoiceSource: '',
                    busSysId: '',
                    buySysName: '',
                    diskCode: '',
                    diskId: '',
                    ukeyCode: '',
                    ukeyId: '',
                    invType: '62',
                }
                $scope.profileType = '201'
            }
            $scope.customizedConfig = {
                version: 1.18,
                queryForm: [
                    {
                        //0
                        label: '申请日期',
                        selected: true,
                        default: true,
                    },
                    {
                        label: '购方名称',
                        selected: true,
                        default: true,
                    },
                    {
                        label: '购方信用代码',
                        selected: true,
                        default: true,
                    },
                    {
                        label: '申请人',
                        selected: false,
                        default: false,
                    },
                    {
                        label: '审核状态',
                        selected: false,
                        default: false,
                    },
                    {
                        label: '数据来源',
                        selected: false,
                        default: false,
                    },
                    {
                        label: '业务系统',
                        selected: false,
                        default: false,
                    },
                    {
                        label: '开票点',
                        selected: false,
                        default: false,
                    },
                    {
                        label: '单据编号',
                        selected: false,
                        default: false,
                    },
                    {
                        label: '是否差额',
                        selected: false,
                        default: false,
                    },
                    {
                        label: '扩展1',
                        selected: false,
                        default: false,
                    },
                    {
                        label: '扩展2',
                        selected: false,
                        default: false,
                    },
                    {
                        label: '扩展3',
                        selected: false,
                        default: false,
                    },
                    {
                        label: '业务单据号',
                        selected: false,
                        default: false,
                    },
                    {
                        label: '合同号',
                        selected: false,
                        default: false,
                    },
                    {
                        label: '项目名称',
                        selected: false,
                        default: false,
                    },
                    {
                        label: '特定业务类型',
                        selected: false,
                        default: false,
                    },
                    {
                        label: '开票状态',
                        selected: false,
                        default: false,
                    },
                    {
                        label: '机构名称',
                        selected: false,
                        default: false,
                    },
                ],
                table: [
                    {
                        label: '单据编号',
                        selected: false,
                        default: false,
                    },
                    {
                        label: '发票ID',
                        selected: false,
                        default: false,
                    },
                    {
                        label: '购方名称',
                        selected: true,
                        default: true,
                    },
                    {
                        label: '购方信用代码',
                        selected: true,
                        default: true,
                    },
                    {
                        label: '购方地址',
                        selected: false,
                        default: false,
                    },
                    {
                        label: '购方电话',
                        selected: false,
                        default: false,
                    },
                    {
                        label: '购方开户行',
                        selected: false,
                        default: false,
                    },
                    {
                        label: '购方银行账号',
                        selected: false,
                        default: false,
                    },
                    {
                        label: '申请日期',
                        selected: true,
                        default: true,
                    },
                    {
                        label: '审核状态',
                        selected: false,
                        default: false,
                    },
                    {
                        label: '开票失败原因',
                        selected: true,
                        default: true,
                    },
                    {
                        label: '合计金额',
                        selected: true,
                        default: true,
                    },
                    {
                        label: '合计税额',
                        selected: true,
                        default: true,
                    },
                    {
                        label: '价税合计',
                        selected: false,
                        default: false,
                    },
                    {
                        label: '含税折扣金额',
                        selected: false,
                        default: false,
                    },
                    {
                        label: '备注',
                        selected: false,
                        default: false,
                    },
                    {
                        label: '主商品名称',
                        selected: false,
                        default: false,
                    },
                    {
                        label: '税率',
                        selected: false,
                        default: false,
                    },
                    {
                        label: '开票点',
                        selected: false,
                        default: false,
                    },
                    {
                        label: '是否差额',
                        selected: false,
                        default: false,
                    },
                    {
                        label: '差额征收类型',
                        selected: false,
                        default: false,
                    },
                    {
                        label: '关联销售单',
                        selected: false,
                        default: false,
                    },
                    {
                        label: '数据来源',
                        selected: false,
                        default: false,
                    },
                    {
                        label: '申请人',
                        selected: false,
                        default: false,
                    },
                    {
                        label: '发票种类',
                        selected: false,
                        default: false,
                    },
                    {
                        label: '业务单据号',
                        selected: false,
                        default: false,
                    },
                    {
                        label: '开票状态',
                        selected: true,
                        default: true,
                    },
                    {
                        label: '特定业务类型',
                        selected: false,
                        default: false,
                    },
                ],
            }
            httpRequest.get_getUserCustomized($scope.profileType).then((res) => {
                if (res.data.value) {
                    const { orderMap } = JSON.parse(res.data.value)
                    if (orderMap) {
                        $scope.orderMap = orderMap
                    }
                }
                if ($scope.orderMap.sortKey) {
                    $scope.param.orderMap[$scope.orderMap.sortKey] = $scope.orderMap.sortVal
                }
                if (!localStorage[stroageStr]) {
                    localStorage.setItem(stroageStr, JSON.stringify($scope.param))
                }
                queryList()
            })
        }
        // 根据权限 判断页面tab页签展示
        $scope.active = ''
        if (operationService.hasPermit('fullEleInvoice_show')) {
            $scope.active = 1
        } else if (operationService.hasPermit('fullEleSpeInvoice_show')) {
            $scope.active = 2
        }
        $scope.tabChange($scope.active)
        let searchParam = localStorage[stroageStr] ? JSON.parse(localStorage[stroageStr]) : $scope.param
        for (const paramKey in searchParam.param) {
            switch (paramKey) {
                case 'applyDateBegin':
                    break
                case 'applyDateEnd':
                    break
                case 'invType':
                    break
                default:
                    if (searchParam.param[paramKey]) {
                        $scope.toggle = true
                    }
            }
        }
        // 状态按钮滑过
        $scope.showCheckStream = function (row, flag) {
            row.dropdowstatenhover = flag
        }
        $scope.showOpenErrorModal = function showOpenErrorModal(data) {
            utils.loaded()
            const modalInstance = $uibModal.open({
                template: ModalPage,
                controller: [
                    '$scope',
                    '$uibModalInstance',
                    function controller($scope, $uibModalInstance) {
                        $scope.error = data.error
                        $scope.success = data.success
                        $scope.total = data.total
                        $scope.pageNum = 1
                        $scope.pageSize = 10
                        const errorLen = data.messageList.length
                        $scope.pagedList = data.messageList.slice(0, $scope.pageSize)
                        $scope.pageCount = errorLen / $scope.pageSize + (errorLen % $scope.pageSize > 0 ? 1 : 0)
                        $scope.errorLen = errorLen
                        $scope.handlePageChange = function handlePageChange() {
                            const start = ($scope.pageNum - 1) * $scope.pageSize
                            const end = Math.min(errorLen, $scope.pageNum * $scope.pageSize)
                            $scope.pagedList = data.messageList.slice(start, end)
                            $scope.$apply()
                        }

                        $scope.confirm = function confirm() {
                            queryList()
                            $uibModalInstance.close(true)
                        }
                        $scope.cancel = function cancel() {
                            $uibModalInstance.close()
                        }
                    },
                ],
                openedClass: 'mod-modal',
                backdrop: 'static',
            })
        }
        // 下载导入模板
        $scope.downOvatBill = function () {
            window.open(`${host.etcloudOvat}dlTaskService/export_OVAT_INVOICE_ALL_ELE?accessToken=${localStorage.getItem('id_token')}`)
        }
        $scope.open = function () {
            if (!JSON.parse(localStorage.user_info).sale) {
                logger.logError('该机构未配置纳税人信息，不能进行该操作')
                return
            }
            $scope.item = {
                queryOvatBillList: queryList,
                code: 'OVAT_INVOICE_ALL_ELE',
            }
            const modalInstance = $uibModal.open({
                templateUrl: './app/outputManage/fillOpenManage/ovatBill/view/ovatBillModalCtrl.html',
                controller: 'ovatBillModalCtrl',
                openedClass: 'et-ovat-bill-modal mod-modal mod-modal-lg',
                backdrop: 'static',
                resolve: {
                    items1() {
                        return $scope.item
                    },
                },
            })
            modalInstance.result.then(
                () => {
                    queryList()
                },
                () => {}
            )
        }
        // 下载电子专票导入模板
        $scope.downOvatBillEle = function () {
            window.open(`${host.etcloudOvat}dlTaskService/export_OVAT_INVOICE_ALL_ELE_SPEC?accessToken=${localStorage.getItem('id_token')}`)
        }
        $scope.importEle = function () {
            if (!JSON.parse(localStorage.user_info).sale) {
                logger.logError('该机构未配置纳税人信息，不能进行该操作')
                return
            }
            $scope.item = {
                queryOvatBillList: queryList,
                code: 'OVAT_INVOICE_ALL_ELE_SPEC',
            }
            const modalInstance = $uibModal.open({
                templateUrl: './app/outputManage/fillOpenManage/ovatBill/view/ovatBillModalCtrl.html',
                controller: 'ovatBillModalCtrl',
                openedClass: 'et-ovat-bill-modal mod-modal mod-modal-lg',
                backdrop: 'static',
                resolve: {
                    items1() {
                        return $scope.item
                    },
                },
            })
            modalInstance.result.then(
                () => {
                    queryList()
                },
                () => {}
            )
        }
        $scope.manualContact = async function () {
            if (!$scope.selectedInvoices.length) {
                return logger.logError('请选择要关联的数据')
            }
            if ($scope.selectedInvoices.length > 1) {
                return logger.logError('只能选择一条数据进行关联')
            }
            let item = $scope.selectedInvoices[0]
            let invoiceId = item.invoiceId
            const flag = await httpRequest.post_checkAssociation(invoiceId).then((res) => {
                return res.data.value
            })
            if (!flag) return

            const modalInstance = $uibModal.open({
                template: manualContactModal,
                controller: 'manualContactModal',
                openedClass: 'mod-modal mod-modal-so-hg',
                backdrop: 'static',
                resolve: {
                    items1() {
                        return item
                    },
                },
            })
            modalInstance.result.then(
                (inv) => {
                    item.electricInvoiceNum = inv.electricInvoiceNum
                    item.invoiceDate = inv.invoiceDate
                    httpRequest.post_makeAssociations(item).then((res) => {
                        logger.logSuccess('手工关联成功')
                        queryList()
                    })
                },
                () => {}
            )
        }

        // 导出设置
        $scope.exportCollapsed = false
        $scope.exportID = 212
        $scope.exportConfig = {
            version: 1.24,
            // 发票主体信息
            mainInfo: [
                {
                    label: '单据编号',
                    selected: true,
                    default: true,
                },
                {
                    label: '发票种类',
                    selected: true,
                    default: true,
                },
                {
                    label: '发票性质',
                    selected: true,
                    default: true,
                },
                {
                    label: '发票ID',
                    selected: true,
                    default: true,
                },
                {
                    label: '申请时间',
                    selected: true,
                    default: true,
                },
                {
                    label: '申请人',
                    selected: true,
                    default: true,
                },
                {
                    label: '申请理由',
                    selected: true,
                    default: true,
                },
                {
                    label: '购方名称',
                    selected: true,
                    default: true,
                },
                {
                    label: '购方信用代码',
                    selected: true,
                    default: true,
                },
                {
                    label: '购方地址',
                    selected: false,
                    defaultWord: false,
                },
                {
                    label: '购方电话',
                    selected: false,
                    defaultWord: false,
                },
                {
                    label: '购方开户行',
                    selected: false,
                    defaultWord: false,
                },
                {
                    label: '购方银行账号',
                    selected: false,
                    defaultWord: false,
                },
                {
                    label: '合计金额',
                    selected: true,
                    default: true,
                },
                {
                    label: '合计税额',
                    selected: true,
                    default: true,
                },
                {
                    label: '价税合计',
                    selected: false,
                    default: false,
                },
                {
                    label: '含税折扣金额',
                    selected: false,
                    default: false,
                },
                {
                    label: '是否差额',
                    selected: false,
                    default: false,
                },
                {
                    label: '差额征收类型',
                    selected: false,
                    default: false,
                },
                {
                    label: '特定业务类型',
                    selected: false,
                    default: false,
                },
                {
                    label: '开票点编号',
                    selected: false,
                    default: false,
                },
                {
                    label: '开票状态',
                    selected: false,
                    default: false,
                },
                {
                    label: '开票失败原因',
                    selected: false,
                    default: false,
                },
                {
                    label: '数据来源',
                    selected: false,
                    default: false,
                },
                {
                    label: '业务单据号',
                    selected: false,
                    default: false,
                },
                {
                    label: '合同号',
                    selected: false,
                    default: false,
                },
                {
                    label: '项目名称',
                    selected: false,
                    default: false,
                },
                {
                    label: '扩展1',
                    selected: false,
                    default: false,
                },
                {
                    label: '扩展2',
                    selected: false,
                    default: false,
                },
                {
                    label: '扩展3',
                    selected: false,
                    default: false,
                },
                {
                    label: '备注',
                    selected: true,
                    defaultWord: true,
                },
            ],
            // 发票明细信息
            detailInfo: [
                {
                    label: '发票种类',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '发票ID',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '货物或应税劳务服务名称',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '简称',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '规格型号',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '单位',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '数量',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '单价',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '金额',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '税率',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '税额',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '零税率标识',
                    selected: true,
                    defaultWord: true,
                },
            ],
            // 建筑服务
            buildingInfo: [
                {
                    label: '发票ID',
                    selected: false,
                    defaultWord: false,
                },
                {
                    label: '建筑服务发生地',
                    selected: false,
                    defaultWord: false,
                },
                {
                    label: '发生地详细地址',
                    selected: false,
                    defaultWord: false,
                },
                {
                    label: '建筑项目名称',
                    selected: false,
                    defaultWord: false,
                },
                {
                    label: '土地增值税项目编号',
                    selected: false,
                    defaultWord: false,
                },
                {
                    label: '跨地市标志-建筑服务',
                    selected: false,
                    defaultWord: false,
                },
            ],
            // 不动产租赁
            realEstateInfo: [
                {
                    label: '发票ID',
                    selected: false,
                    defaultWord: false,
                },
                {
                    label: '房屋产权证书/不动产权证号码',
                    selected: false,
                    defaultWord: false,
                },
                {
                    label: '不动产地址',
                    selected: false,
                    defaultWord: false,
                },
                {
                    label: '不动产详细地址',
                    selected: false,
                    defaultWord: false,
                },
                {
                    label: '租赁期起',
                    selected: false,
                    defaultWord: false,
                },
                {
                    label: '租赁期止',
                    selected: false,
                    defaultWord: false,
                },
                {
                    label: '跨地市标志-不动产租赁',
                    selected: false,
                    defaultWord: false,
                },
                {
                    label: '面积单位',
                    selected: false,
                    defaultWord: false,
                },
            ],
        }
        $scope.exportSetting = function exportSetting() {
            exportSettingService($scope.exportID, $scope.exportConfig)
        }
        // 导出
        $scope.exportInvoic = function () {
            let getdata = $.extend({}, $scope.param.param)
            const idArr = []
            $scope.selectedInvoices.forEach((item) => {
                idArr.push(item.invoiceId)
            })
            getdata.idList = idArr.join(',')
            let url = `${host.etcloudOvat}tax4/wait/ordinaryElectricalWait/exportInvoiceToXls` // 全部票据
            url = `${url}?accessToken=${localStorage.getItem('id_token')}`
            for (let i = 0; i < $scope.param.orderMap.length; i++) {
                getdata.sortField = `${i}:${$scope.param.orderMap[i]}`
            }
            utils.file_download(
                url,
                getdata,
                '', //type
                'POST',
                'blob',
                '',
                false
            )
            //utils.post_downLoadEncode(getdata, url)
        }
        // 导出
        $scope.exportInvoicSpe = function () {
            let getdata = $.extend({}, $scope.param.param)
            const idArr = []
            $scope.selectedInvoices.forEach((item) => {
                idArr.push(item.invoiceId)
            })
            getdata.idList = idArr.join(',')
            let url = `${host.etcloudOvat}tax4/wait/specialElectricalWait/exportInvoiceToXls` // 全部票据
            url = `${url}?accessToken=${localStorage.getItem('id_token')}`
            for (let i = 0; i < $scope.param.orderMap.length; i++) {
                getdata.sortField = `${i}:${$scope.param.orderMap[i]}`
            }
            utils.file_download(
                url,
                getdata,
                '', //type
                'POST',
                'blob',
                '',
                false
            )
            //utils.post_downLoadEncode(getdata, url)
        }
        function invStatusCheck(list) {
            let invStatus = list.some((el) => el.invoiceSource == 'interface' && el.openStatus == '2')
            if (!$scope.invoicPermissions && invStatus) {
                logger.logError('数据来源为“接口”且开票状态为“失败”的发票限制手工开具，请业务系统源头发起。')
                return false
            }
            return true
        }
    }
}
fullElectricInvoiceListCtrl.$inject = ['$scope', '$uibModal', 'logger', 'httpRequest', '$state', 'getOvatAmtService', 'sweetalert', 'invoiceOpenService', 'initSortService', '$timeout', '$q', 'resultTipService', 'batchHandle', 'getCodeAndNumber', 'batchFilterService', 'operationService', '$filter', 'exportSettingService']



// WEBPACK FOOTER //
// ./src/app/outputManage/fullElectricInvoice/fullEleInvoice/list.js